import { TprecmAuthorizationService } from './authorization/tprecm-authorization.service';
import { BuildDesignWeightModalComponent } from './administration/build-design-weight-modal/build-design-weight-modal.component';
import { ChangeLogModalComponent } from './administration/change-log-modal/change-log-modal.component';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../modules/user.service';
import { TprecmApiService } from '../../../modules/api/tprecm-api.service';
import { SourceMaintenanceModalService } from './table-maintenance/source-maintenance-modal/source-maintenance-modal.service';
import { ReasonCodeMaintenanceModalService } from './administration/reason-code-maintenance-modal/reason-code-maintenance-modal.service';
import { SpanMaintenanceModalService } from './administration/span-maintenance-modal/span-maintenance-modal.service';
import { UserMaintenanceModalService } from './administration/user-maintenance-modal/user-maintenance-modal.service';
import { CgpSnackbarService } from '../../shared/cgp-snackbar/cgp-snackbar.service';
import { FileDownloadService } from '../../shared/file-download/file-download.service';
import { forkJoin } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { FileUploadSummaryModalService } from './reporting/file-upload-summary/file-upload-summary-modal.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBarRef as MatSnackBarRef, LegacySimpleSnackBar as SimpleSnackBar } from '@angular/material/legacy-snack-bar';
import { ProgramMaintenanceComponent } from './table-maintenance/program-maintenance/program-maintenance.component';
import { config } from '../../../config/config';
import { getEnv } from '../../../modules/utility';
import { filter, finalize, map } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TprecmUserProfile } from 'src/modules/api/tprecm-api.interface';
import { BatchJobMaintenanceModalComponent } from './administration/batch-job-maintenance-modal/batch-job-maintenance-modal.component';

const DOWNLOADING_ATTACHMENT = 'Downloading Attachment...';
const SNACKBAR_ACTION = 'Dismiss';
const EGM_DOWNLOAD_URI = 'report/egm/download';
const TMACS_FIXTURE_COMPARE_DOWNLOAD_URI = 'report/tmacs/fixture-compare/download';
const MASTER_DOWNLOAD_URI = 'report/master/download';
const PROGRAM_DOWNLOAD_URI = 'report/program/download';
const REGIONAL_DOWNLOAD_URI = 'report/regional/download';
const QUOTE_COMPLIANCE_DOWNLOAD_URI = 'report/quote-comp/download';
const METRICS_DOWNLOAD_URI = 'report/metrics/download';
const MISSING_PROGRAM_INFO_CHART_DOWNLOAD_URI = 'report/missing-program-metrics/download';
const DESIGN_DOWNLOAD_URI = 'report/design/download';
const FIXTURE_BUILD_URI = 'https://dynamics-ssrs.gm.com/reports/report/TMaCS Datamart ADHOC/A-Z/CFBuild';
const FIXTURE_REQUEST_URI = 'https://dynamics-ssrs.gm.com/reports/report/TMaCS Datamart ADHOC/A-Z/Checking Fixtures Requirements';

const MINIMUM_1_AREA = 'You must select at least one Area.';
const ONLY_1_AREA = 'You must select only one Program to view the report.';
@Component({
   templateUrl: './tprecm.template.html',
   styleUrls: ['./tprecm.style.scss']
})
export class TprecmComponent implements OnInit {

   display = 'loading';

   form: UntypedFormGroup = new UntypedFormGroup({
      programs: new UntypedFormControl([]),
      areas: new UntypedFormControl([]),
      keyword: new UntypedFormControl(null),
      engineer: new UntypedFormControl(null),
      partNoLH: new UntypedFormControl(null),
      cspcLH: new UntypedFormControl(null),
      gageNo: new UntypedFormControl(null),
      constEngineer: new UntypedFormControl(null),
      designSourceRep: new UntypedFormControl(null),
      partNoRH: new UntypedFormControl(null),
      cspcRH: new UntypedFormControl(null),
      fixtureType: new UntypedFormControl(null),
      firstUserSource: new UntypedFormControl(null),
      designSource: new UntypedFormControl(null),
      userSource: new UntypedFormControl(null),
      buildSource: new UntypedFormControl(null)
   });

   criteria: { [key: string]: any } = {
      areas: ['BIW', 'DEI', 'GAE']
   };

   constructor(
      private readonly dialog: MatDialog,
      private readonly userService: UserService,
      private readonly tprecmApiService: TprecmApiService,
      private readonly sourceMaintenanceModalService: SourceMaintenanceModalService,
      private readonly reasonCodeMaintenanceModalService: ReasonCodeMaintenanceModalService,
      private readonly spanMaintenanceModalService: SpanMaintenanceModalService,
      private readonly userMaintenanceModalService: UserMaintenanceModalService,
      private readonly cgpSnackbarService: CgpSnackbarService,
      private readonly fileDownloadService: FileDownloadService,
      private readonly fileUploadSummaryModalService: FileUploadSummaryModalService,
      private readonly toastr: ToastrService,
      public readonly router: Router,
      private readonly authorization: TprecmAuthorizationService
   ) { }

   onEgmReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptEgm_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, EGM_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   });

   onMasterReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptMaster_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, MASTER_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   });

   onProgramReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptProgram_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, PROGRAM_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   });

   onRegionalReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptRegional_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, REGIONAL_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   });

   onQuoteComplianceReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptQuoteCompliance_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, QUOTE_COMPLIANCE_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   });

   onMetricsReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptMetrics_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, METRICS_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   }, null);

   onDesignReportClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptDesign_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFileWithBody(filename, DESIGN_DOWNLOAD_URI, this.getParams())
         .subscribe(() => ref.dismiss());
   });

   onFixtureCompareClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const date = new Date();
      const filename = `rptTMaCsCFReq_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
      this.fileDownloadService.downloadFile(TMACS_FIXTURE_COMPARE_DOWNLOAD_URI, filename)
         .subscribe(() => ref.dismiss());
   }, null);

   onMissingProgramInfoChartClick = this.reportDownloadHandler((ref: MatSnackBarRef<SimpleSnackBar>) => {
      const userProfile = this.userService.UserProfile;
      const selectedProgram = this.form.get('programs').value[0];

      // format the current date to what TPRECM expects
      const date = new Date();
      const formattedMonth = `0${date.getUTCMonth() + 1}`.slice(-2);
      const formattedDay = `0${date.getUTCDate()}`.slice(-2);
      const year = date.getUTCFullYear();

      // formatting file name
      const filename = `rptTPRMissingProgramInfo_`
         + `${selectedProgram.programNameYear}_`
         + `${userProfile.lastName.toUpperCase()}, ${userProfile.firstName.toUpperCase()}_`
         + `${year}-${formattedMonth}-${formattedDay}-.xlsx`;
      const url = `${config.tprecmApiBaseUrl[getEnv()]}${MISSING_PROGRAM_INFO_CHART_DOWNLOAD_URI}`;
      const body = this.getParamForMissingReport();

      this.fileDownloadService.downloadExcel(url, body, { filename })
         .subscribe(() => ref.dismiss());
   }, this.checkSelections.bind(this, true));

   ngOnInit() {
      this.form.get('areas').setValue(this.criteria.areas);

      this.router.events
         .pipe(
            filter(event => event instanceof NavigationEnd),
            filter((event: NavigationEnd) => event.urlAfterRedirects === '/tprecm')
         ).subscribe((event: NavigationEnd) => this.loadLists());

      this.userService.userProfile
         .pipe(filter(Boolean))
         .subscribe((value: TprecmUserProfile) => this.loadLists());
   }

   loadLists() {
      forkJoin([
         this.tprecmApiService.getActivePrograms(),
         this.tprecmApiService.getEngineers(),
         this.tprecmApiService.getFixtureTypes(),
         this.tprecmApiService.getGageNoList(),
         this.tprecmApiService.getPartNoLHList(),
         this.tprecmApiService.getPartNoRHList(),
         this.tprecmApiService.getCspcLHList(),
         this.tprecmApiService.getDesignSourceReps(),
         this.tprecmApiService.getCspcRHList(),
         this.tprecmApiService.getDesignSources(),
         this.tprecmApiService.getUserSources(),
         this.tprecmApiService.getConstEngineers(),
         this.tprecmApiService.getBuildSources(),
         this.tprecmApiService.getFirstUserSources()
      ])
         .pipe(finalize(() => this.display = 'loaded'))
         .subscribe(([programs, engineers, fixtureTypes, gageNoList, partNoLHList, partNoRHList, cspcLHList,
            designSourceReps, cspcRHList, designSources, userSources, constEngineers, buildSources, firstUserSources
         ]) => {
            this.criteria = {
               ...this.criteria, programs, engineers, fixtureTypes, gageNoList, partNoLHList, partNoRHList, cspcLHList,
               designSourceReps, cspcRHList, designSources, userSources, constEngineers, buildSources, firstUserSources
            };

            const selections = JSON.parse(sessionStorage.getItem('selections'));
            if (selections !== null) {
               this.form.patchValue(selections);
            }
         });
   }

   programsEqual(l: any, r: any) {
      return l && r && l.id === r.id;
   }

   loadSources() {
      forkJoin([
         this.tprecmApiService.getDesignSources(),
         this.tprecmApiService.getUserSources(),
         this.tprecmApiService.getBuildSources(),
         this.tprecmApiService.getFirstUserSources()
      ]).subscribe(([designSources, userSources, buildSources, firstUserSources]) =>
         this.criteria = { ...this.criteria, designSources, userSources, buildSources, firstUserSources }
      );
   }

   reportDownloadHandler(callback: Function, allowed = this.checkSelections.bind(this)) {
      return () => {
         if (allowed && !allowed()) {
            return;
         }

         const ref = this.cgpSnackbarService.showSnackbar({
            message: DOWNLOADING_ATTACHMENT,
            action: SNACKBAR_ACTION,
            duration: null
         });

         callback(ref);
      };
   }

   checkSelections(programRequired = false): boolean {
     
      const hasSelectedArea = this.form.get('areas').value.length > 0;

      let MinMessage = hasSelectedArea ? null : MINIMUM_1_AREA;
      let MaxMessage = hasSelectedArea ? null : ONLY_1_AREA;

      MinMessage = programRequired && this.form.get('programs').value.length < 1 ? 'You must select one program to view reports' : MinMessage;
      MaxMessage = programRequired && this.form.get('programs').value.length > 1 ? 'You must only select one program to view report' : MaxMessage;

      if (MinMessage) {
         this.toastr.error(MinMessage, 'Invalid Selections');
      }

      if (MaxMessage) {
         this.toastr.error(MaxMessage, 'Invalid Selections');
      }

      return !MinMessage && !MaxMessage;
   }

   private getParam(obj: any, id: string): any | undefined {
      return obj ? obj[id] : undefined;
   }

   private getParams() {
      const selections = this.form.value;
      const programIds = this.form.get('programs').value.map((p: any) => p.id);

      return {
         programIds: programIds.length > 0 ? programIds : undefined,
         chkBiw: selections.areas.includes('BIW'),
         chkDei: selections.areas.includes('DEI'),
         chkGae: selections.areas.includes('GAE'),
         engineerId: this.getParam(selections.engineer, 'id'),
         partNumber: this.getParam(selections.partNoLH, 'partNumber'),
         stablePartCode1: this.getParam(selections.cspcLH, 'stablePartCode1'),
         toolNo: this.getParam(selections.gageNo, 'toolNo'),
         cfe: this.getParam(selections.constEngineer, 'cfe'),
         dsRep: this.getParam(selections.designSourceRep, 'dsRep'),
         partNumber2: this.getParam(selections.partNoRH, 'partNumber2'),
         stablePartCode2: this.getParam(selections.cspcRH, 'stablePartCode2'),
         typeId: this.getParam(selections.fixtureType, 'id'),
         firstUserSourceId: this.getParam(selections.firstUserSource, 'id'),
         designSourceId: this.getParam(selections.designSource, 'id'),
         userSourceId: this.getParam(selections.userSource, 'id'),
         constSourceId: this.getParam(selections.buildSource, 'id'),
         toolName: selections.keyword || undefined
      };
   }

   private getParamForMissingReport() {
      const selections = this.form.value;

      return {
         programIds: selections.programs.map(p => p.id),
         chkBiw: selections.areas.includes('BIW'),
         chkDei: selections.areas.includes('DEI'),
         chkGae: selections.areas.includes('GAE'),
      };
   }

   onFixtureBuildClick() {
      window.open(FIXTURE_BUILD_URI, '_blank');
   }

   onFixtureRequestClick() {
      window.open(FIXTURE_REQUEST_URI, '_blank');
   }

   onMenuItemClick(menuItem) {
      alert('MenuItem: ' + menuItem);
   }

   onProgramMaintenanceClick() {
      this.dialog.open(ProgramMaintenanceComponent,
         {
            height: '96vh',
            autoFocus: true,
            disableClose: true,
            panelClass: 'tprecm-modal-panel',
         });
   }

   onTprInactiveClick(url) {
      if (this.form.get('areas').value.length === 0) {
         this.toastr.error(MINIMUM_1_AREA, 'Invalid Selection Criteria');
      } else {
         this.saveSelections();
         this.router.navigate([url]);
      }
   }


   onSourcesMenuItemClick() {
      const dialog = this.sourceMaintenanceModalService.showModal();

      dialog.afterClosed()
         .pipe(filter((res: { sourcesChanged: boolean }) => res.sourcesChanged))
         .subscribe(() => this.loadSources());
   }

   onReasonCodesMenuItemClick() {
      this.reasonCodeMaintenanceModalService.showModal();
   }

   onClassesMenuItemClick() {
      this.spanMaintenanceModalService.showModal();
   }

   onUsersMenuItemClick() {
      this.userMaintenanceModalService.showModal();
   }

   onBatchJobsMenuItemClick() {
      this.dialog.open(BatchJobMaintenanceModalComponent,
         {
            disableClose: true,
            autoFocus: true,
            width: '30vw',
            height: '72vh',
         }).afterClosed().subscribe();
   }

   onBuildDesignWeightsItemClick() {
      this.dialog.open(BuildDesignWeightModalComponent,
         {
            disableClose: true,
            autoFocus: true,
            width: '74vw',
            height: '74vh',
         }).afterClosed().subscribe();
   }

   onFileUploadSummaryClick() {
      this.fileUploadSummaryModalService.showModal();
   }

   onViewingMenuItemClick(url) {
      if (this.form.get('areas').value.length === 0) {
         this.toastr.error(MINIMUM_1_AREA, 'Invalid Selection Criteria');
      } else {
         this.saveSelections();
         this.router.navigate([url]);
      }
   }

   onChangeLogClick() {
      this.dialog.open(ChangeLogModalComponent,
         {
            disableClose: true,
            autoFocus: true,
            width: '74vw',
            height: '74vh',
         }).afterClosed().subscribe();
   }

   private saveSelections() {
      sessionStorage.setItem('selections', JSON.stringify(this.form.value));
   }

   private clearSavedSelections() {
      sessionStorage.clear();
   }

   isSuperUser() {
      return this.authorization.userRoleId()
         .pipe(map(id => id === 1));
   }

   onClearSelectionClick() {
      this.clearSavedSelections();
      this.form.reset({ areas: this.criteria.areas, programs: [] });
   }
}
